import request from '@/utils/request';

// 快速理赔--快速理赔列表查询
export function queryQuickIndemnityListApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: 'quickIndemnity/queryList',
    method: 'post',
    data
  });
 }
// 快速理赔--快速理赔列表导出
export function exportQuickIndemnityListApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/quickIndemnity/exportList',
    method: 'post',
    data,
    responseType: 'blob'
  });
}
// 快速理赔--理赔类型查询
export function getIndemnityTypeApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/quickIndemnity/getIndemnityType',
    method: 'get',
    params: data
  })
}
// 快速理赔--店铺列表查询
export function getMallsOfUserByQuickIndemnityApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/quickIndemnity/getMallsOfUser',
    method: 'get',
    params: data
  })
}
// 快速理赔--收款账号解密接口
export function queryDecrypByQuickIndemnitytApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: 'quickIndemnity/queryDecrypt',
    method: 'post',
    data
  });
 }
 // 获取快速理赔支付宝电子回单
export function getDownloadBillReceiptApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/quickIndemnity/downloadBillReceipt?alipaySerialNo=' + data,
    method: 'get'
  });
}